export const FETCH_MAIL_LIST_FETCH_INIT = 'SETTINGS|MAIL_FETCH_INIT';
export const FETCH_MAIL_LIST_START = 'SETTINGS|MAIL_FETCH_START';
export const FETCH_MAIL_LIST_SUCCESS = 'SETTINGS|MAIL_FETCH_SUCCESS';
export const FETCH_MAIL_LIST_FAIL = 'SETTINGS|MAIL_FETCH_FAIL';
